(() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __moduleCache = /* @__PURE__ */ new WeakMap();
  var __toCommonJS = (from) => {
    var entry = __moduleCache.get(from),
      desc;
    if (entry) return entry;
    entry = __defProp({}, "__esModule", { value: true });
    if ((from && typeof from === "object") || typeof from === "function")
      __getOwnPropNames(from).map(
        (key) =>
          !__hasOwnProp.call(entry, key) &&
          __defProp(entry, key, {
            get: () => from[key],
            enumerable:
              !(desc = __getOwnPropDesc(from, key)) || desc.enumerable,
          }),
      );
    __moduleCache.set(from, entry);
    return entry;
  };
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, {
        get: all[name],
        enumerable: true,
        configurable: true,
        set: (newValue) => (all[name] = () => newValue),
      });
  };

  // assets/scripts/media-gallery.ts
  var exports_media_gallery = {};
  __export(exports_media_gallery, {
    MediaGallery: () => MediaGallery,
  });

  // utils/debounce.ts
  function debounce(fn, delay) {
    let timeoutId = null;
    return (...args) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => fn(...args), delay);
    };
  }

  // assets/scripts/media-gallery.ts
  class MediaGallery extends HTMLElement {
    elements;
    mql;
    stickyHeader;
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
      };
      this.mql = window.matchMedia("(min-width: 768px)");
      if (!this.elements.thumbnails) return;
      this.elements.viewer?.addEventListener(
        "slideChanged",
        debounce(this.onSlideChanged.bind(this), 500),
      );
      this.elements.thumbnails
        .querySelectorAll("[data-target]")
        .forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector("button")
            ?.addEventListener(
              "click",
              this.setActiveMedia.bind(
                this,
                mediaToSwitch.dataset.target,
                false,
              ),
            );
        });
      if (this.dataset.desktopLayout?.includes("thumbnail") && this.mql.matches)
        this.removeListSemantic();
    }
    onSlideChanged(event) {
      const customEvent = event;
      const thumbnail = this.elements.thumbnails?.querySelector(
        `[data-target="${customEvent.detail.currentElement.dataset.mediaId}"]`,
      );
      this.setActiveThumbnail(thumbnail);
    }
    setActiveMedia(mediaId, prepend) {
      const activeMedia =
        this.elements.viewer?.querySelector(`[data-media-id="${mediaId}"]`) ||
        this.elements.viewer?.querySelector("[data-media-id]");
      if (!activeMedia) {
        return;
      }
      this.elements.viewer
        ?.querySelectorAll("[data-media-id]")
        .forEach((element) => {
          element.classList.remove("is-active");
        });
      activeMedia?.classList?.add("is-active");
      if (prepend) {
        if (
          activeMedia.parentElement &&
          activeMedia.parentElement.firstChild !== activeMedia
        ) {
          activeMedia.parentElement.prepend(activeMedia);
        }
        if (this.elements.thumbnails) {
          const activeThumbnail2 = this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`,
          );
          if (
            activeThumbnail2?.parentElement &&
            activeThumbnail2.parentElement.firstChild !== activeThumbnail2
          ) {
            activeThumbnail2.parentElement.prepend(activeThumbnail2);
          }
        }
        if (this.elements.viewer?.slider) this.elements.viewer.resetPages?.();
      }
      this.preventStickyHeader();
      window.setTimeout(() => {
        if (!this.mql.matches || this.elements.thumbnails) {
          activeMedia.parentElement?.scrollTo({
            left: activeMedia.offsetLeft,
          });
        }
      });
      this.playActiveMedia(activeMedia);
      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(
        `[data-target="${mediaId}"]`,
      );
      this.setActiveThumbnail(activeThumbnail);
      if (activeThumbnail) {
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition,
        );
      }
    }
    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;
      this.elements.thumbnails
        .querySelectorAll("button")
        .forEach((element) => element.removeAttribute("aria-current"));
      thumbnail.querySelector("button")?.setAttribute("aria-current", "true");
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
      this.elements.thumbnails.slider?.scrollTo({
        left: thumbnail.offsetLeft,
      });
    }
    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector(
        ".product__modal-opener--image img",
      );
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion?.setAttribute("aria-hidden", "false");
        if (this.elements.liveRegion && position) {
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position,
            );
        }
        setTimeout(() => {
          this.elements.liveRegion?.setAttribute("aria-hidden", "true");
        }, 2000);
      };
      image.src = image.src;
    }
    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector(".deferred-media");
      if (deferredMedia) deferredMedia.loadContent(false);
    }
    preventStickyHeader() {
      this.stickyHeader =
        this.stickyHeader || document.querySelector("sticky-header");
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
    }
    removeListSemantic() {
      if (!this.elements.viewer?.slider) return;
      this.elements.viewer.slider.setAttribute("role", "presentation");
      if (this.elements.viewer.sliderItems) {
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation"),
        );
      }
    }
  }
  if (!customElements.get("media-gallery")) {
    customElements.define("media-gallery", MediaGallery);
  }
})();
